<template>
  <b-pagination
    v-model="currentPage"
    :total-rows="totalRows"
    :per-page="perPage"
    :aria-controls="tableId"
    :align="align"
  ></b-pagination>
</template>

<script>
import { BPagination } from "bootstrap-vue"
export default {
  name: "AtomPagination",
  components: {
    BPagination,
  },
  props: {
    tableId: {
      type: String,
      required: false,
    },
    totalRows: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: false,
      default: 10,
    },
    align: {
      type: String,
      required: false,
      default: "right"
    },
    value: {
      type: Number,
      required: true,
      default: 0
    },
  },
  data() {
    return {}
  },
  computed: {
    currentPage: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
